import React from "react";
import { useSelector } from "react-redux";
import Modal from "../../Elements/Modal/Modal";
import BetSelector from "../UI/BetSelector/BetSelector";

const BetsModal = () => {
  const { modalOpen } = useSelector((state) => state.modal);

  return (
    <Modal name="bets" modifier="modalBets" active={modalOpen} title="bet">
      <BetSelector />
    </Modal>
  );
};

export default BetsModal;
